module.exports = __webpack_public_path__ + "img/bom1.fb894b97.png";